import { EURO_COUNTRY_CODES } from '../constants/countries';

export const detectCurrency = (countryCode: string | null) => {
  if (!countryCode) return 'usd';
  if (EURO_COUNTRY_CODES.includes(countryCode)) return 'eur';
  if (countryCode === 'JP') return 'jpy';
  if (countryCode === 'KR') return 'krw';
  return 'usd';
};
